module.exports = __webpack_public_path__ + "media/images/chevron-right-a24f6c41.png";